const icons = {
  back: 'carbon:arrow-left',
  bike: 'mdi:bike',
  brain: 'mdi:brain',
  chat: 'material-symbols-light:chat-outline',
  checkCircle: 'mdi:check-circle',
  close: 'carbon:close-filled',
  x: 'carbon:close',
  delete: 'mingcute:delete-2-line',
  eye: 'tabler:eye',
  eyeOff: 'tabler:eye-off',
  heart: 'mdi:heart',
  help: 'carbon:help',
  home: 'iconamoon:home',
  image: 'material-symbols:image',
  instagram: 'mdi:instagram',
  lightning: 'mdi:lightning-bolt',
  log: 'el:pencil-alt',
  logout: 'carbon:logout',
  map: 'carbon:map',
  megaphone: 'fluent:megaphone-loud-24-filled',
  person: 'material-symbols:person',
  pin: 'ooui:map-pin',
  play: 'material-symbols:play-circle-outline',
  plus: 'material-symbols:add',
  question: 'ep:question-filled',
  reply: 'material-symbols:reply',
  run: 'mdi:run-fast',
  search: 'ion:search',
  shop: 'material-symbols:shopping-cart',
  team: 'fluent:people-team-16-filled',
  trophy: 'material-symbols:trophy',
  up: 'tabler:arrow-up',
  walk: 'mdi:walk',
  text: 'material-symbols:text-format',
  highlight: 'material-symbols:format-ink-highlighter',
  bold: 'material-symbols:format-bold',
  italic: 'material-symbols:format-italic',
  underline: 'material-symbols:format-underline',
  align: {
    left: 'material-symbols:format-align-left',
    center: 'material-symbols:format-align-center',
    right: 'material-symbols:format-align-right',
    justify: 'material-symbols:format-align-justify',
  },
  list: {
    bullet: 'material-symbols:format-list-bulleted',
    numbered: 'material-symbols:format-list-numbered',
  },
  left: 'tabler:arrow-left',
  right: 'tabler:arrow-right',
  error: 'material-symbols:error',
  copy: 'material-symbols:content-copy',
}

export default icons
